export default "__VITE_ASSET__BgPmE4b6__"